import * as Sentry from "@sentry/react";

export function initSentry() {
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment:
      process.env.REACT_APP_APP_ENV ||
      process.env.REACT_APP_NODE_ENV ||
      process.env.NODE_ENV ||
      "development",
    release: process.env.REACT_APP_SENTRY_RELEASE || process.env.REACT_APP_VERSION,
    integrations: [Sentry.browserTracingIntegration(), Sentry.browserProfilingIntegration()],
    tracesSampleRate: Number(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || "0.1"),
    profileSessionSampleRate: Number(
      process.env.REACT_APP_SENTRY_PROFILE_SESSION_SAMPLE_RATE || "0.1"
    ),
    profileLifecycle: "trace",
    sendDefaultPii: false,
  });

  captureSlowPageLoad();
}

export function captureException(error, context = {}) {
  Sentry.withScope((scope) => {
    Object.entries(context).forEach(([key, value]) => {
      scope.setContext(key, value);
    });
    Sentry.captureException(error);
  });
}

export function captureSlowOperation(name, durationMs, thresholdMs, context = {}) {
  const critical = durationMs >= 10000;
  Sentry.withScope((scope) => {
    scope.setLevel(critical ? "error" : "warning");
    scope.setTag("slow_operation", "true");
    scope.setTag("operation", name);
    scope.setTag("critical_slow_operation", String(critical));
    scope.setContext("slow_operation", {
      duration_ms: Math.round(durationMs),
      threshold_ms: thresholdMs,
      ...context,
    });
    Sentry.captureMessage(`Slow operation: ${name}`);
  });
}

function captureSlowPageLoad() {
  if (typeof window === "undefined" || typeof performance === "undefined") return;
  window.addEventListener(
    "load",
    () => {
      const navigation = performance.getEntriesByType("navigation")[0];
      const durationMs = navigation?.duration ?? performance.now();
      const thresholdMs = Number(process.env.REACT_APP_SENTRY_SLOW_PAGE_LOAD_THRESHOLD_MS || "3000");
      if (durationMs >= thresholdMs) {
        captureSlowOperation("console_frontend_page_load", durationMs, thresholdMs, {
          path: window.location.pathname,
        });
      }
    },
    { once: true }
  );
}
